// import i18n from '../../main';

/**
 *薪酬管理菜单
 */
export default [
  {
    label: 'payroll', // 薪酬服务
    // permission: 'wage_sys_menu',
    img: true,
    icon: 'icon-xinchoufuwu',
    id:5,
    children: [
      {
        path: '/wage/data-ready-template',
        label: 'dataPreparation',  // 数据准备
        permission: 'hr_wage__new_data_ready',
        icon: 'icon-yonghu',
        id:5-1
      },
      {
        path: '/wage/wageHistory',
        label: 'salaryHistory',  // 薪酬历史
        permission: 'hr_wage_new_his',
        icon: 'icon-yonghu',
        id: 5-2
      },
      {
        path: '/wage/paymentWage',
        label: 'salaryDistribution',  // 薪酬发放
        permission: 'hr_wage_new_pay',
        icon: 'icon-yonghu',
        id: 5-3

      },
      {
        path: '/wage/salaryTax',
        label: 'IITDeclaration',  // 个税申报
        permission: 'hr_wage_new_tax',
        icon: 'icon-yonghu',
        id: 5-4

      },
      {
        path: '/payrollSettings/onePayHistory',
        label: 'paySlipOnly',  // 仅工资条
        permission: 'hr_wage_new_only_wage',
        icon: 'icon-yonghu',
        id: 5-7
      },
      {
        path: '/wage/salarySet',
        label: 'salarySetting',  // 薪酬设置
        permission: 'hr_wage_new_set',
        icon: 'icon-yonghu',
        id: 5-8
      },

      {
        path: '/wage/refundTabs',
        label: 'refund',  // 退票
        permission: 'set_refundtitcket',
        icon: 'icon-yonghu',
        id: 5-9
      },
      {
        path: '/hrms/wage/wageCalculate.do',
        label: 'salaryCalculation',  // 薪资正算
        permission: 'wage_forward_calculate',
        icon: 'icon-yonghu',
        id: 5-10
      },
      {
        path: '/hrms/wage/wageUnCalculate.do',
        label: 'salaryBackCalculation',  // 薪资倒算
        permission: 'wage_reverse_calculate',
        icon: 'icon-yonghu',
        id: 5-11
      }
    ]
  },
  {
    label: 'approvalProcess', // 审批流程
    // permission: 'hr_manage_menu',
    img: true,
    icon: 'icon-shenpiliucheng',
    id:6,
    children: [
      {
        path: '/wage/salaryApproval',
        label: 'salaryApproval',  // 薪酬审批
        permission: 'hr_wage_new_approve',
        icon: 'icon-yonghu',
        id: 6-1
      },
      {
        path: '/approval/toindex.action',
        label: 'approvalSettings',  // 审批设置
        permission: 'set_approve',
        icon: 'icon-yonghu',
        id: 6-2
      },
      // {
      //   path: '/wage/payment',
      //   label: '付款通知单审批',
      //   // label: i18n.messages[i18n.locale].payApvlSet.processName,
      //   permission: 'set_paymentnotice_approve',
      //   icon: 'icon-yonghu',
      //   id: 6-3,
      // },
      {
        path: '/wage/paymentApproval',
        label: 'billApprovalSettings', // 付款通知单审批设置
        permission: 'set_paymentnoticesetting_approve',
        icon: 'icon-yonghu',
        id: 6-5
      }
    ]
  },
  {
    label: 'process',  // 服务流程
    permission: 'set_fwlc_wage',
    img: true,
    icon: 'icon-shenpiliucheng',
    id:21,
    children: [
      {
        path: '/v2/service-process/order',
        label: 'orderCenter',  // 订单中心
        permission: 'wage_order',
        icon: 'icon-yonghu',
        id: 21-1
      },
      {
        path: '/v2/service-process/bill',
        label: 'billList',  // 账单列表
        permission: 'set_fwlc_bill_list',
        icon: 'icon-yonghu',
        id: 21-2
      },
      {
        path: '/v2/service-process/invoice',
        label: 'invoiceList',  // 发票列表
        permission: 'set_fwlc_invoice_list',
        icon: 'icon-yonghu',
        id: 21-3
      }
    ]
  },
  {
    label: 'payslip',    //工资单预览
    permission: 'set_paysilp_serve',
    img: true,
    icon: 'icon-shenpiliucheng',
    id: 22,
    children: [
      {
        path: '/payslip/unpaybatchinfo',
        label: 'unpaybatchinfo',  // 发放中工资单
        permission: 'set_unpay_paysilp_batch',
        icon: 'icon-yonghu',
        id: 22-1
      },
      {
        path: '/payslip/detail',
        label: 'payslipdetail',  // 发放后工资单
        permission: 'set_payed_paysilp',
        icon: 'icon-yonghu',
        id: 22-2
      },
    ]
  },
  {
    label: 'ProofMenu',    //证明开具
    permission: 'proof_menu_serve',
    img: true,
    icon: 'icon-proof',
    id: 23,
    children: [
      {
        path: '/incomeProof/detail',
        label: 'incomeProofMenu',  // 薪资证明开具
        permission: 'proof_wage_menu_serve',
        icon: 'icon-yonghu',
        id: 23-1
      }
    ]
  },
  {
    label: 'meritDataManagement',
    permission: 'set_merit_management',
    icon: 'icon-meritDataManagement',
    img: true,
    id:24,
    children: [
      {
        path: '/merit/batch',
        label: 'meritDataManagement',
        permission: 'set_merit_management',
        component:'',
        icon: 'icon-yonghu',
        id: 24-1,
      },
      {
        path: '/merit/debtDetailsForHR',
        label: 'meritDetail',
        permission: 'set_merit_management_hr',
        icon: 'icon-yonghu',
        id: 24-2,
      },
    ]
  },
  {
    label: 'seagateFile',  // 希捷文件
    permission: 'hr_seagate',
    img: true,
    id: 25,
    icon: 'icon-yonghu',
    children: [
      {
        path: '/seagate/seagate-file',
        label: 'seagateFileDownload',   // 希捷文件
        permission: 'hr_seagate_fileDownload',
        id: 25-1,
        icon: 'icon-yonghu',
      },
      {
        path: '/seagate/finance-report',
        label: 'seagateFinanceReport',   // 希捷财务报表
        permission: 'hr_seagate_financeReport',
        id: 25-2,
        icon: 'icon-yonghu',
      }
    ]
  }
]
